(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !window.DesignMode) return;
  try {
    

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    let scrollPoint = 200;

    if($(window).width() < 768) {
      scrollPoint = 100;
    }

    if(scroll > scrollPoint) {
      $('header nav').addClass('active');
    } else {
      $('header nav').removeClass('active');
    }
    position = scroll;
});


  } catch(e) { console.error(e); }
})();
})();
